import styled from 'styled-components';

import {colors} from '../../../../../../theme';
import {Icon} from '../../../../../ui-kit/Icon';

export const CancelIcon = styled(Icon)`
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translate(-100%, -50%);

    svg {
        stroke: ${colors.textSecondary};
    }

    :hover {
        svg {
            stroke: ${colors.textPrimary};
        }
    }
`;
